const ALLOWED_APP_HOSTS: ReadonlySet<string> = new Set<string>([
    'gamelift.dev.gameloop.tv',
    'gamelift.stage.gameloop.tv',
    'gamelift.gameloop.tv'
]);

export class GameLoopEnvironmentConfig {
    private readonly _appHost: string;
    private readonly _authTokenUrl: URL;

    constructor(currentHost: string, overrideHost?: string | null) {
        const hasOverride = typeof overrideHost === 'string' && overrideHost.trim().length > 0;
        const candidate = (hasOverride ? (overrideHost as string) : currentHost).toLowerCase().trim();

        if (!ALLOWED_APP_HOSTS.has(candidate)) {
            throw new Error(`Unrecognized app_host: ${candidate}`);
        }

        this._appHost = candidate;
        this._authTokenUrl = this._buildAuthTokenUrl(candidate);
    }

    public get appHost(): string {
        return this._appHost;
    }

    public get authTokenUrl(): URL {
        return this._authTokenUrl;
    }

    private _buildAuthTokenUrl(appHost: string): URL {
        const authHost = appHost.replace(/^gamelift\./, 'auth.');
        const authCandidate = `https://${authHost}/auth/token`;
        try {
            return new URL(authCandidate);
        } catch (_error) {
            throw new Error(`Cannot derive auth URL from ${appHost}`);
        }
    }
}
